"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unfollowCollection = exports.followCollection = exports.unfollowCollectionUrl = exports.followCollectionUrl = exports.getCollectionEvents = exports.deleteCollection = exports.editCollection = exports.createCollection = exports.getCollectionsForOnline = exports.getCollectionsForPlace = exports.getFollowedCollections = exports.getUserCollections = exports.removeFromCollection = exports.removeFromCollectionUrl = exports.addToCollection = exports.addToCollectionUrl = void 0;

var _http = require("js-utils/http");

var _urlLib = require("url-lib");

var _transformation = require("../../utils/transformation");

/*
Summary of the endpoints needed for interacting wtih collections on the user profile page.
*/
var addToCollectionUrl = function addToCollectionUrl(collectionId) {
  return "/api/v3/destination/collections/".concat(collectionId, "/events/add/");
};

exports.addToCollectionUrl = addToCollectionUrl;

var addToCollection = function addToCollection(eventId, collectionId) {
  return (0, _http.sdkRequest)(addToCollectionUrl(collectionId), {
    method: 'POST',
    body: JSON.stringify({
      event_ids: [eventId]
    })
  });
};

exports.addToCollection = addToCollection;

var removeFromCollectionUrl = function removeFromCollectionUrl(collectionId) {
  return "/api/v3/destination/collections/".concat(collectionId, "/events/remove/");
};

exports.removeFromCollectionUrl = removeFromCollectionUrl;

var removeFromCollection = function removeFromCollection(eventId, collectionId) {
  return (0, _http.sdkRequest)(removeFromCollectionUrl(collectionId), {
    method: 'POST',
    body: JSON.stringify({
      event_ids: [eventId]
    })
  });
};

exports.removeFromCollection = removeFromCollection;

var getUserCollections = function getUserCollections(userId, continuation) {
  return (0, _http.sdkRequest)((0, _urlLib.formatUrl)('/api/v3/destination/collections/', {
    continuation: continuation,
    user_id: userId,
    filter: 'can_curate'
  }));
};

exports.getUserCollections = getUserCollections;

var getFollowedCollections = function getFollowedCollections(userId, continuation) {
  return (0, _http.sdkRequest)((0, _urlLib.formatUrl)("/api/v3/destination/users/".concat(userId, "/following/collections/"), {
    continuation: continuation,
    'expand.collection': ['image_large', 'follow_status']
  }));
};

exports.getFollowedCollections = getFollowedCollections;

var getCollectionsForPlace = function getCollectionsForPlace(placeId, continuation) {
  return (0, _http.sdkRequest)((0, _urlLib.formatUrl)("/api/v3/destination/collections/".concat(placeId, "/editorial-collections"), {
    continuation: continuation,
    'expand.collection': ['image_large', 'follow_status']
  }));
};

exports.getCollectionsForPlace = getCollectionsForPlace;

var getCollectionsForOnline = function getCollectionsForOnline(continuation) {
  return (0, _http.sdkRequest)((0, _urlLib.formatUrl)('/api/v3/destination/collections/?is_online=true', {
    continuation: continuation,
    'expand.collection': ['image_large', 'follow_status']
  }));
}; // POST
// Body: {
//     event_ids: [],
//     collection: {
//         name,
//         summary
//     }
// }
// Resppnse: {
//     can_admin: true
//     can_curate: true
//     can_edit: true
//     event_count: 1
//     id: "ccq"
//     image_id: null
//     is_quality: false
//     name: "Vincent's Test Collection"
//     summary: "Oh wow!"
// }


exports.getCollectionsForOnline = getCollectionsForOnline;
var CREATE_COLLECTION_URL = '/api/v3/destination/collections/';

var createCollection = function createCollection(name, eventIds) {
  return (0, _http.sdkRequest)(CREATE_COLLECTION_URL, {
    method: 'POST',
    body: JSON.stringify((0, _transformation.pruneObject)({
      collection: {
        name: name
      },
      event_ids: eventIds
    }))
  });
};

exports.createCollection = createCollection;

var editCollection = function editCollection(id, name) {
  return (0, _http.sdkRequest)("".concat(CREATE_COLLECTION_URL).concat(id, "/"), {
    method: 'POST',
    body: JSON.stringify({
      collection: {
        name: name
      }
    })
  });
};

exports.editCollection = editCollection;

var deleteCollection = function deleteCollection(id) {
  return (0, _http.sdkRequest)("/api/v3/destination/collections/".concat(id, "/delete/"), {
    method: 'POST',
    body: JSON.stringify({
      collection_id: id
    })
  });
};

exports.deleteCollection = deleteCollection;

var getCollectionEvents = function getCollectionEvents(_ref) {
  var collectionId = _ref.collectionId,
      continuation = _ref.continuation,
      filter = _ref.filter,
      secret = _ref.secret,
      _ref$pageSize = _ref.pageSize,
      pageSize = _ref$pageSize === void 0 ? 20 : _ref$pageSize;
  return (0, _http.sdkRequest)((0, _urlLib.formatUrl)("/api/v3/destination/collections/".concat(collectionId, "/events/"), {
    'expand.destination_event': ['primary_venue', 'image', 'ticket_availability', 'saves', 'my_collections'],
    dates: filter,
    page_size: pageSize,
    continuation: continuation,
    secret: secret
  }));
};

exports.getCollectionEvents = getCollectionEvents;

var followCollectionUrl = function followCollectionUrl(id) {
  return "/api/v3/destination/collections/".concat(id, "/follow/");
};

exports.followCollectionUrl = followCollectionUrl;

var unfollowCollectionUrl = function unfollowCollectionUrl(id) {
  return "/api/v3/destination/collections/".concat(id, "/unfollow/");
};

exports.unfollowCollectionUrl = unfollowCollectionUrl;

var followCollection = function followCollection(collectionId) {
  return (0, _http.sdkRequest)(followCollectionUrl(collectionId), {
    method: 'POST'
  });
};

exports.followCollection = followCollection;

var unfollowCollection = function unfollowCollection(collectionId) {
  return (0, _http.sdkRequest)(unfollowCollectionUrl(collectionId), {
    method: 'POST'
  });
};

exports.unfollowCollection = unfollowCollection;
//# sourceMappingURL=api.js.map